import SearchIcon from "@mui/icons-material/Search";
import { InputBase, styled } from "@mui/material";
import { setLibraryRecentSearch } from "components/app/App.slice";
import Typography from "components/common/Typography";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { minSearchStrLength } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import "./index.scss";

const AskBoost = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const dispatch = useAppDispatch();
  const loggedInUserDetails = getLoggedInUserDetails();

  const [isFocused, setFocuedOut] = React.useState<boolean>(false);

  const { isCorp, isConsultant, isAbovePropertyUserFetched, isAbovePropertyUser } = useAppSelector(
    (state) => state.app.loggedInUserDetails
  );

  const isHotelUser = !isCorp && !isConsultant && !isAbovePropertyUser && isAbovePropertyUserFetched;
  const [searchField, setSearchField] = useState<string>("");
  const libraryRecentSearch = useAppSelector((state) => state.app.libraryRecentSearch);

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center"
  }));

  const persistRecentSearch = (result: any) => {
    const updatedSearches = [result, ...(libraryRecentSearch || [])];
    dispatch(setLibraryRecentSearch(updatedSearches));
  };

  function searchItems(query: string, list: any) {
    if (!query && query.length < 3) return list; // if search box empty, return all
    const lowerQuery = query.toLowerCase();
    return list.filter((item: any) => item.toLowerCase().includes(lowerQuery));
  }

  return (
    <div
      className={`ask-boost-component ${currentPath === "/" && isHotelUser ? "" : "d-none"}`}
      style={{ position: "relative" }}
    >
      <div className="ask-boost-container">
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <InputBase
          className="input-base"
          onFocus={() => setFocuedOut(true)}
          onBlur={() => setFocuedOut(false)}
          onChange={(e: any) => {
            setSearchField(e.target?.value);
          }}
          placeholder="Search BOOST"
          value={searchField}
          inputProps={{
            onKeyPress: (event: any) => {
              if (event.key === "Enter") {
                const withoutLeadingSpace = searchField.replace(/^\s+/, "");
                if (withoutLeadingSpace.length > minSearchStrLength) {
                  persistRecentSearch(searchField);
                  setSearchField("");
                  navigate({
                    pathname: "/library/search",
                    search: `?q=${encodeURIComponent(searchField)}`
                  });
                }
              }
            }
          }}
        />
        {isFocused && Array.isArray(libraryRecentSearch) && (
          <div className="ask-recent-search-wrapper">
            {searchItems(searchField, libraryRecentSearch)?.map((data: any) => {
              return (
                <div
                  className="cursor-pointer boost-recent-search-list"
                  style={{ minHeight: "32px", display: "flex", padding: "16px", alignItems: "center" }}
                  onMouseDown={(e: React.MouseEvent) => {
                    navigate({
                      pathname: "/library/search",
                      search: `?q=${encodeURIComponent(data)}`
                    });
                    setSearchField("");
                  }}
                >
                  <Typography sx={{ marginX: "8px" }} variant={"body2"} color="#4E4846">
                    {data}
                  </Typography>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default AskBoost;
